import { lazyLoad } from 'utils/loadable';

const PostDetailsPage = lazyLoad(() =>
  import(/*  webpackChunkName: 'postDetailsPage', webpackPrefetch: true */ '.'),
);

// routes declaration
export const postDetailsRoute = {
  component: PostDetailsPage,
  path: '/post/:postId',
  title: 'Post Details',
  hidePublicNavbar: true,
  hideCustomFooter: true,
  allowedAfterLogin: true,
  disableFullScroll: true,
};
